// Same anatomy as shadcn/ui's Switch; a native button needs no new dependency.
import * as React from "react";
import { cn } from "../../lib/utils";

export const Switch = React.forwardRef<
  HTMLButtonElement,
  Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, "onChange"> & {
    checked: boolean;
    onCheckedChange: (checked: boolean) => void;
  }
>(({ checked, onCheckedChange, className, ...props }, ref) => (
  <button
    ref={ref}
    type="button"
    role="switch"
    aria-checked={checked}
    className={cn("vl-switch", className)}
    onClick={() => onCheckedChange(!checked)}
    {...props}
  >
    <span className="vl-switch-thumb" />
  </button>
));
Switch.displayName = "Switch";
